const formatterCache = new Map()

const getFormatter = (options: Intl.DateTimeFormatOptions): (locale: string, date: Date) => string => {
  return (locale: string, date: Date): string => {

    if (!formatterCache.has(locale)) {
      formatterCache.set(locale, new Map())
    }

    const formatterCacheLocale = formatterCache.get(locale)

    if (!formatterCacheLocale.has(options)) {
      formatterCacheLocale.set(
        options,
        new Intl.DateTimeFormat(locale, options).format
      )
    }

    return formatterCacheLocale.get(options)(toSafeHour(date))
  }
}

const toSafeHour = (date: Date): Date => {
  const safeDate = new Date(date)
  return new Date(safeDate.setHours(12))
}

const formatMonthOptions: Intl.DateTimeFormatOptions = { month: 'long' }
const formatMonthYearOptions: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' }
const formatWeekdayOptions: Intl.DateTimeFormatOptions = { weekday: 'short' }
const formatDisplayBirthDateOptions: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' }
const formatDisplayAppointmentDateOptions: Intl.DateTimeFormatOptions = { weekday:'long', day: 'numeric', month: 'long', year: 'numeric' }

const formatMonth = (locale: string, date: Date) => {
  return getFormatter(formatMonthOptions)(locale, date)
}

const formatMonthYear = (locale: string, date: Date) => {
  return getFormatter(formatMonthYearOptions)(locale, date)
}

const formatShortWeekday = (locale: string, date: Date) => {
  return getFormatter(formatWeekdayOptions)(locale, date)
}

const formatDisplayBirthDate = (locale: string, date: Date) => {
  return getFormatter(formatDisplayBirthDateOptions)(locale, date)
}
const formatDisplayAppointmentDate = (locale: string, date: Date) => {
  return getFormatter(formatDisplayAppointmentDateOptions)(locale, date)
}

export {
  formatMonth,
  formatMonthYear,
  formatShortWeekday,
  formatDisplayBirthDate,
  formatDisplayAppointmentDate
}
